import { Chip, Stack, Typography } from '@mui/material';
import { ActionIconArrowRightSmall } from '@vs-online-only-app/ui';

export const TransferRequestBadge = () => (
  <Chip
    color="success"
    size="small"
    sx={{ width: 'fit-content' }}
    label={
      <Stack gap={0.5} alignItems="center" direction="row">
        <ActionIconArrowRightSmall />
        <Typography variant="caption">Transfer request</Typography>
      </Stack>
    }
  />
);
